import { useState } from 'react'
import { Container } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { useTranslation } from 'react-i18next'
import FriendTable from './components/FriendTable'

function FriendPage() {
	const { t } = useTranslation()

	const [key, setKey] = useState(t('friendpage.all_friend'))

	return (
		<Container fluid className="rankpage-container">
			<div className="d-flex justify-content-between align-items-center my-3">
				<h1>{t('friendpage.title')}</h1>
				<Nav activeKey={key} onSelect={k => setKey(k)}>
					<NavDropdown title={key} align="end" id="nav-dropdown">
						<NavDropdown.Item eventKey={t('friendpage.all_friend')}>
							{t('friendpage.all_friend')}
						</NavDropdown.Item>
						<NavDropdown.Item eventKey={t('friendpage.contact_only')}>
							{t('friendpage.contact_only')}
						</NavDropdown.Item>
					</NavDropdown>
				</Nav>
			</div>
			<FriendTable />
		</Container>
	)
}

export default FriendPage
